<template>
  <div>
    <!--Header Components-->
    <base-header class="pb-6" type="">
      <b-row class="align-items-center py-4">
        <b-col lg="6" cols="7">
          <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
          <h6 class="h2 d-inline-block mb-0">{{ language_terms[$route.name] }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <!--contents-->
    <b-container fluid class="mt--6 container-padding">
      <b-row>
        <div>
            <loading :active="loadCounter > 0" 
                color= '#007bff'
                :width= '128'
                :height= '128'
                loader='dots'
                :can-cancel="true" 
                :is-full-page="true">
            </loading>
        </div>
        <b-col lg="12">
          <div class="card-wrapper">
            <b-card no-body>
              <b-tabs pills card>
                <!--Basic information Tab-->
                <b-tab :title="language_terms['BASIC_INFORMATION']" active>
                  <b-card-text>
                    <card>
                      <div slot="header">
                        <b-row>
                          <b-col lg="6">
                              <h3>{{language_terms['BASIC_INFORMATION']}} 
                                  <span v-if="customer.code">({{customer.code}})</span>
                              </h3>
                          </b-col>
                          <!-- <b-col lg="6" >
                              <base-button icon type="danger" class="float-right" @click="deleteCustomer" v-if="$route.params.id != '_new'">
                                  <span class="btn-inner--text">{{language_terms['DELETE']}}</span>
                              </base-button>
                          </b-col> -->
                        </b-row>
                      </div>
                      <b-row>
                        <b-col md="9">
                          <base-input :label="language_terms['NAME']" v-model="customer.name" :disabled="customerDisabled"></base-input>
                        </b-col>
                        <b-col md="3">
                          <base-input :label="language_terms['DEFAULT_ACCOUNT']">
                            <el-select :disabled="customerDisabled" v-model="customer.default_debtor_account_code" filterable>
                              <el-option
                                :disabled="customerDisabled"
                                v-for="option in debtor_accounts"
                                :key="option.code"
                                :label="option.name"
                                :value="option.code">
                              </el-option>
                            </el-select>
                          </base-input>
                        </b-col>
                      </b-row>
                      <b-row class="mb-4">
                        <b-col md="3">
                          <base-input :label="language_terms['COUNTRY']">
                            <el-select v-model="customer.country_code" filterable :disabled="customerDisabled">
                              <el-option v-for="option in countries" :key="option.code" :label="option.name" :value="option.code"></el-option>
                            </el-select>
                          </base-input>
                        </b-col>
                        <b-col md="2">
                          <base-input :label="language_terms['CURRENCY']">
                            <el-select v-model="customer.currency_code" filterable :disabled="customerDisabled" :placeholder="language_terms['CURRENCY_CODE']">
                              <el-option v-for="option in currencies" :key="option.id" :label="option.code + ' (' + option.prefix + ')'" :value="option.code"></el-option>
                            </el-select>
                          </base-input>
                        </b-col>
                        <b-col md="2">
                          <base-input :label="language_terms['TAX_CODE']">
                            <el-select :disabled="customerDisabled" v-model="customer.customer_tax_code" filterable :placeholder="language_terms['TAX_CODE']">
                              <el-option v-for="option in taxes" :key="option.code" :label="option.code" :value="option.code">
                              </el-option>
                            </el-select>
                          </base-input>
                        </b-col>
                        <b-col md="2">
                          <base-input :disabled="customerDisabled" :label="language_terms['CREDIT_LIMIT']" type="number" v-model="customer.customer_credit_limit"></base-input>
                        </b-col>
                        <b-col md="1">
                          <base-input :disabled="customerDisabled" :label="language_terms['CREDIT_TERMS']" v-model="customer.customer_credit_term"></base-input>
                        </b-col>
                        <b-col md="2">
                          <base-input :disabled="customerDisabled" :label="language_terms['PAYMENT_TERMS']" v-model="customer.customer_payment_term"></base-input>
                        </b-col>
                        <b-col md="6">
                          <label class="form-control-label">{{language_terms['SALESPERSONS']}}</label>
                          <multiselect
                                  :tag-placeholder="language_terms['ADD_NEW_TAG']"
                                  :placeholder="language_terms['SEARCH_ADD_TAG']"
                                  open-direction="bottom"
                                  label="name"
                                  track-by="linked_contact_id"
                                  :options="salesperson_list"
                                  text-field="name"
                                  :multiple="true"
                                  v-model="customer.salepersons"
                                  :taggable="false"
                                  :disabled="customerDisabled"
                          ></multiselect>
                        </b-col>                        
                        <b-col md="3">
                            <label class="form-control-label">{{language_terms['CONTACT_CATEGORIES']}}</label>
                            <multiselect
                                    :placeholder="language_terms['SEARCH']"
                                    open-direction="bottom"
                                    label="name"
                                    track-by="id"
                                    :options="contact_categories"
                                    text-field="name"
                                    :multiple="true"
                                    v-model="customer.contact_categories"
                                    :taggable="false"
                                    :disabled="customerDisabled">
                            </multiselect>
                        </b-col>
                        <b-col md="3" v-if="loadCounter == 0">
                          <base-input :label="language_terms['SALE_CHANNEL']">
                            <el-select :disabled="customerDisabled" v-model="customer.salechannel_id" filterable>
                              <el-option
                                :disabled="customerDisabled"
                                v-for="option in salechannels"
                                :key="option.id"
                                :label="option.name"
                                :value="option.id">
                              </el-option>
                            </el-select>
                          </base-input>

                        </b-col>                        
                        <b-col md="12">
                          <base-input :label="language_terms['REMARKS']">
                            <textarea :disabled="customerDisabled" class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="customer.remarks"></textarea>
                          </base-input>
                        </b-col>

                      </b-row>
                    </card>
                    <card>
                      <h3 slot="header">
                        {{ language_terms["ADDRESS_INFORMATION"] }}
                      </h3>
                      <b-row>
                        <b-col md="12">
                          <!-- <base-input
                            :disabled="customerDisabled"
                            :label="language_terms['STREET']"
                            type="text"
                            v-model="customer.address_street"
                          ></base-input> -->
                          <base-input :label="language_terms['STREET']">
                            <textarea
                              class="form-control"
                              id="exampleFormControlTextarea1"
                              rows="3"
                              v-model="customer.address_street"
                              :disabled="customerDisabled">
                            </textarea>
                          </base-input>

                        </b-col>
                        <!-- <b-col md="4">
                          <base-input label="City" v-model="customer.address_city"></base-input>
                        </b-col> -->
                        <b-col md="4">
                          <base-input
                            :label="
                              language_terms['STATE'] +
                              '/' +
                              language_terms['PROVINCE']
                            "
                            v-model="customer.address_province"
                            :disabled="customerDisabled"
                          >
                          </base-input>
                        </b-col>
                        <b-col md="4">
                          <base-input
                            :disabled="customerDisabled"
                            :label="language_terms['POSTCODE']"
                            v-model="customer.address_postcode"
                          ></base-input>
                        </b-col>
                        <b-col md="4">
                          <base-input :label="language_terms['COUNTRY']">
                            <el-select :disabled="customerDisabled" v-model="customer.address_country_code" filterable>
                              <el-option
                                :disabled="customerDisabled"
                                v-for="option in countries"
                                :key="option.code"
                                :label="option.name"
                                :value="option.code">
                              </el-option>
                            </el-select>
                          </base-input>
                          <!-- <base-input label="Country Code" v-model="customer.address_country_code"></base-input> -->
                        </b-col>
                      </b-row>
                    </card>
                    <card>
                      <h3 slot="header">
                        {{ language_terms["CONTACT_INFO"] }}
                      </h3>
                      <b-row>
                        <b-col md="3">
                          <base-input
                            :disabled="customerDisabled"
                            :label="language_terms['CONTACT_PERSON']"
                            v-model="customer.contact_person"
                          ></base-input>
                        </b-col>
                        <b-col md="6">
                          <base-input
                            :disabled="customerDisabled"
                            :label="language_terms['EMAIL']"
                            v-model="customer.contact_email"
                          ></base-input>
                        </b-col>
                        <b-col md="3">
                          <base-input
                            :disabled="customerDisabled"
                            :label="language_terms['TELEPHONE']"
                            v-model="customer.contact_telephone"
                          ></base-input>
                        </b-col>
                        <b-col md="3">
                          <base-input
                            :disabled="customerDisabled"
                            :label="language_terms['TELEPHONE'] + ' #2'"
                            v-model="customer.contact_telephone2"
                          ></base-input>
                        </b-col>
                        <b-col md="3">
                          <base-input
                            :disabled="customerDisabled"
                            :label="language_terms['CONTACT_FAX']"
                            v-model="customer.contact_fax"
                          ></base-input>
                        </b-col>
                        <b-col md="3">
                          <base-input
                            :disabled="customerDisabled"
                            :label="language_terms['CONTACT_FAX'] + ' #2'"
                            v-model="customer.contact_fax2"
                          ></base-input>
                        </b-col>
                        <b-col md="3">
                          <base-input
                            :disabled="customerDisabled"
                            :label="language_terms['MOBILE']"
                            v-model="customer.contact_mobile"
                          ></base-input>
                        </b-col>
                      </b-row>
                    </card>
                    <b-card v-if="0">
                      <h3 slot="header">
                        {{ language_terms["OTHERS"] }}
                      </h3>
                      <b-row>
                        <b-col md="3" v-for = "(meta, i) in customer.metas" :key="i">
                            <label class="form-control-label" v-if="meta.key == 'whatsapp'">{{language_terms["WHATSAPP_MOBILE"]}}</label>
                            <label class="form-control-label" v-if="meta.key == 'facebook'">{{language_terms["FACEBOOK"]}}</label>
                            <base-input :disabled="customerDisabled" v-model="meta.value"></base-input>
                        </b-col>
                      </b-row>
                    </b-card>
                    <!-- <b-row>
                      <b-col md="12" class="mt-3">
                        <base-button icon type="primary" @click="saveCustomer">
                          <span class="btn-inner--text">{{
                            language_terms["SAVE"]
                          }}</span>
                        </base-button>
                        <base-button
                          icon
                          type="warning"
                          @click="cancelCustomer"
                        >
                          <span class="btn-inner--text">{{
                            language_terms["CANCEL"]
                          }}</span>
                        </base-button>
                      </b-col>
                    </b-row> -->
                  </b-card-text>
                  <div class="floating-bar">
                     <div class="floating-bar-container" align="center">
                       <b-button-group>
                          <b-button class="transparent-btn"  @click="editCustomer" v-if="customerDisabled">
                             <i class="fas fa-edit mr-2 text-primary"></i>{{language_terms['EDIT']}}
                          </b-button>
                          <b-button class="transparent-btn"  @click="saveCustomer" v-if="!customerDisabled">
                             <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}}
                          </b-button>
                          <b-button class="transparent-btn"  @click="cancelCustomer" v-if="!customerDisabled">
                             <i class="fa fa-times mr-2 text-warning"></i>{{language_terms['CANCEL']}}
                          </b-button>
                          <b-button class="transparent-btn" @click="deleteCustomer" v-if="$route.params.id != '_new'">
                             <i class="fas fa-trash mr-2 text-danger"></i>{{language_terms['DELETE']}}
                          </b-button>
                       </b-button-group>
                     </div>
                  </div>
                      <!-- <div>
                         <a href="javascript:void(0)" class="float-button" @click="editCustomer" style="background-color:#2dce89" v-if="customerDisabled">
                            <i class="fas fa-edit my-float-button"></i>
                          </a>
                          <a href="javascript:void(0)" class="float-button "  @click="cancelCustomer" style="background-color:#fb6340" v-if="!customerDisabled">
                              <i class="fa fa-times  my-float-button"></i>
                          </a>
                          <a href="javascript:void(0)" class="float-button mr-6" @click="saveCustomer" style="background-color:#5e72e4" v-if="!customerDisabled">
                              <i class="fas fa-check my-float-button"></i>
                          </a>
                      </div> -->
                </b-tab>
                <b-tab :title="language_terms['BUSINESS_UNITS']" v-if="show_unit_tab && 0">
                  <b-card-text>
                    <b-row>
                      <b-col lg="12" v-for="(item, index) of customer.units" :key="index">
                        <b-card>
                            <b-row>
                              <b-col lg="10">
                                <h5 class="mb-0">{{ item.name }}</h5>
                              </b-col>
                              <b-col lg="2">
                                <base-button @click="handleCollaspe(index, item)" size="sm" icon type="success" class="float-right mr-1"><i class="fa fa-angle-down"></i></base-button>
                                <base-button @click="deleteUnit(item)" size="sm" icon type="danger" class="float-right mr-4"><i class="fas fa-trash-alt"></i ></base-button>
                              </b-col>
                            </b-row>
                            <b-collapse v-model="item.is_collapsed" class="mt-2">
                                <b-row>
                                  <b-col lg="12">
                                    <card>
                                  <h3 slot="header">
                                    {{ language_terms["BASIC_INFORMATION"] }}
                                  </h3>
                                  <b-row>
                                    <b-col md="12">
                                      <base-input
                                        label="Name"
                                        v-model="item.name"
                                      >
                                      </base-input>
                                    </b-col>
                                  </b-row>
                                  <b-row class="mb-4">
                                    <b-col md="4">
                                      <base-input
                                        :label="language_terms['COUNTRY']"
                                      >
                                        <el-select
                                          v-model="item.country_code"
                                          filterable
                                        >
                                          <el-option
                                            v-for="option in countries"
                                            :key="option.code"
                                            :label="option.name"
                                            :value="option.code"
                                          >
                                          </el-option>
                                        </el-select>
                                      </base-input>
                                    </b-col>
                                    <b-col md="4">
                                      <base-input
                                        :label="language_terms['CURRENCY']"
                                      >
                                        <el-select
                                          v-model="item.currency_code"
                                          filterable
                                          placeholder="Currency Code"
                                        >
                                          <el-option
                                            v-for="option in currencies"
                                            :key="option.id"
                                            :label="
                                              option.code +
                                              ' (' +
                                              option.prefix +
                                              ')'
                                            "
                                            :value="option.code"
                                          >
                                          </el-option>
                                        </el-select>
                                      </base-input>
                                    </b-col>
                                    <b-col md="4">
                                      <base-input
                                        :label="language_terms['TAX_CODE']"
                                      >
                                        <el-select
                                          v-model="item.tax_code"
                                          filterable
                                          :placeholder="
                                            language_terms['TAX_CODE']
                                          "
                                        >
                                          <el-option
                                            v-for="option in taxes"
                                            :key="option.code"
                                            :label="option.code"
                                            :value="option.code"
                                          >
                                          </el-option>
                                        </el-select>
                                      </base-input>
                                    </b-col>
                                  </b-row>
                                  <b-row>
                                    <b-col md="6">
                                      <base-input
                                        :label="language_terms['CREDIT_LIMIT']"
                                        type="number"
                                        v-model="item.customer_credit_limit"
                                      ></base-input>
                                    </b-col>
                                    <b-col md="6">
                                      <base-input
                                        :label="language_terms['CREDIT_TERMS']"
                                        v-model="item.customer_credit_term"
                                      ></base-input>
                                    </b-col>
                                  </b-row>
                                    </card>
                                    <card>
                                      <h3 slot="header">
                                        {{ language_terms["ADDRESS_INFORMATION"] }}
                                      </h3>
                                      <b-row>
                                        <b-col md="12">
                                          <base-input
                                            :label="language_terms['STREET']"
                                            type="text"
                                            v-model="item.address_street"
                                          ></base-input>
                                        </b-col>
                                        <!-- <b-col md="4">
                                                <base-input label="City" v-model="item.address_city"></base-input>
                                              </b-col> -->
                                        <b-col md="4">
                                          <base-input
                                            :label="
                                              language_terms['STATE'] +
                                              '/' +
                                              language_terms['PROVINCE']
                                            "
                                            v-model="item.address_province"
                                          >
                                          </base-input>
                                        </b-col>
                                        <b-col md="4">
                                          <base-input
                                            label="Postcode"
                                            v-model="item.address_postcode"
                                          ></base-input>
                                        </b-col>
                                        <b-col md="4">
                                          <base-input :label="language_terms['COUNTRY']">
                                            <el-select
                                              v-model="item.address_country_code"
                                              filterable
                                            >
                                              <el-option
                                                v-for="option in countries"
                                                :key="option.code"
                                                :label="option.name"
                                                :value="option.code"
                                              >
                                              </el-option>
                                            </el-select>
                                          </base-input>
                                          <!-- <base-input label="Country Code" v-model="item.address_country_code"></base-input> -->
                                        </b-col>
                                      </b-row>
                                    </card>
                                    <card>
                                      <h3 slot="header">{{language_terms['CONTACT_INFO']}}</h3>
                                      <b-row>
                                        <b-col cols="4">
                                          <base-input
                                            :label="language_terms['CONTACT_PERSON']"
                                            v-model="item.contact_person"
                                          ></base-input>
                                        </b-col>
                                        <b-col cols="4">
                                          <base-input
                                            :label="language_terms['EMAIL']"
                                            v-model="item.contact_email"
                                          ></base-input>
                                        </b-col>
                                        <b-col cols="4">
                                          <base-input :label="language_terms['MOBILE']" v-model="item.contact_mobile"></base-input>
                                        </b-col>
                                        <b-col cols="4">
                                          <base-input :label="language_terms['TELEPHONE']" v-model="item.contact_telephone"></base-input>
                                        </b-col>
                                        <b-col cols="4">
                                          <base-input :label="language_terms['FAX']" v-model="item.contact_fax"></base-input>
                                        </b-col>
                                      </b-row>
                                    </card>
                                  </b-col>
                                  <b-col lg="12">
                                       <base-button @click="saveUnit(item)" type="primary" class="mr-1">{{language_terms['SAVE']}}</base-button>
                                  </b-col>
                                </b-row>
                            </b-collapse>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-card-text>
                  <div class="floating-bar">
                    <div class="floating-bar-container" align="center">
                      <b-button-group>
                        <b-button class="transparent-btn"  @click="showaddUnitModal">
                            <i class="fa fa-plus mr-2 text-success"></i>{{language_terms['ADD']}}
                        </b-button>
                      </b-button-group>
                    </div>
                  </div>
                    <!-- <div>
                        <a href="javascript:void(0)" class="float-button "  @click="showaddUnitModal" style="background-color:#136b45" >
                            <i class="fa fa-plus my-float-button"></i>
                        </a>
                    </div> -->
                </b-tab>
                <b-tab :title="language_terms['BANK_INFO']" v-if="show_unit_tab && 0">
                    <bank-accounts :currencies="currencies" :countries="countries" :contact_id="customer.id"  
                    :contact_code="customer.code" :bank_accounts="bank_accounts"></bank-accounts>
                </b-tab>
                <b-tab :title="language_terms['CUSTOMIZED_PRICES'] + ' (' + customer.customized_price_count + ')'" v-if="show_unit_tab && customer.salechannel_id">
                    <card>
                      <price-setup :customized_prices="customer.customized_prices"  :code="customer.code" :module="'customer'"  :customer_id="customer.id" :salechannel_id="customer.salechannel_id"></price-setup>
                    </card>    
                </b-tab>
              </b-tabs>
            </b-card>
            <b-modal v-model="addUnitModal" :header-bg-variant="headerBgVariant" :header-text-variant="headerTextVariant" size="xl" centered no-close-on-backdrop class="my-modal">
              <template #modal-title>
                <span style="color: white">{{language_terms['NEW_BUSINESS_UNIT']}}</span>
              </template>
              <b-row>
                <b-col cols="12">
                  <card>
                    <h3 slot="header">{{language_terms['BASIC_INFORMATION']}}</h3>
                    <b-row>
                      <b-col md="12">
                        <base-input :label="language_terms['NAME']" v-model="business_unit_modal.name"></base-input>
                      </b-col>
                    </b-row>
                    <b-row class="mb-4">
                      <b-col md="2">
                        <base-input :label="language_terms['COUNTRY']">
                          <el-select
                            v-model="business_unit_modal.country_code"
                            filterable
                          >
                            <el-option
                              v-for="option in countries"
                              :key="option.code"
                              :label="option.name"
                              :value="option.code"
                            >
                            </el-option>
                          </el-select>
                        </base-input>
                      </b-col>
                      <b-col md="2">
                        <base-input :label="language_terms['CURRENCY']">
                          <el-select
                            v-model="business_unit_modal.currency_code"
                            filterable
                            :placeholder="language_terms['CURRENCY_CODE']"
                          >
                            <el-option
                              v-for="option in currencies"
                              :key="option.id"
                              :label="option.code + ' (' + option.prefix + ')'"
                              :value="option.code"
                            >
                            </el-option>
                          </el-select>
                        </base-input>
                      </b-col>
                      <b-col md="2">
                        <base-input :label="language_terms['TAX_CODE']">
                          <el-select
                            v-model="business_unit_modal.tax_code"
                            filterable
                            :placeholder="language_terms['CURRENCY_CODE']"
                          >
                            <el-option
                              v-for="option in taxes"
                              :key="option.code"
                              :label="option.code"
                              :value="option.code"
                            >
                            </el-option>
                          </el-select>
                        </base-input>
                      </b-col>
                      <b-col md="3">
                        <base-input
                          :label="language_terms['CREDIT_LIMIT']"
                          type="number"
                          v-model="business_unit_modal.customer_credit_limit"
                        ></base-input>
                      </b-col>
                      <b-col md="3">
                        <base-input
                          :label="language_terms['CREDIT_TERMS']"
                          v-model="business_unit_modal.customer_credit_term"
                        ></base-input>
                      </b-col>
                    </b-row>
                  </card>
                  <card>
                    <h3 slot="header">{{language_terms['CONTACT_INFO']}}</h3>
                    <b-row>
                      <b-col md="12">
                        <base-input
                          :label="language_terms['STREET']"
                          type="text"
                          v-model="business_unit_modal.address_street"
                        ></base-input>
                      </b-col>
                      <!-- <b-col md="4">
                          <base-input label="City" v-model="business_unit_modal.address_city"></base-input>
                        </b-col> -->
                      <b-col md="4">
                        <base-input
                          :label="
                            language_terms['STATE'] +
                            '/' +
                            language_terms['PROVINCE']
                          "
                          v-model="business_unit_modal.address_province"
                        >
                        </base-input>
                      </b-col>
                      <b-col md="4">
                        <base-input
                          :label="language_terms['POSTCODE']"
                          v-model="business_unit_modal.address_postcode"
                        ></base-input>
                      </b-col>
                      <b-col md="4">
                        <base-input :label="language_terms['COUNTRY']">
                          <el-select
                            v-model="business_unit_modal.address_country_code"
                            filterable
                          >
                            <el-option
                              v-for="option in countries"
                              :key="option.code"
                              :label="option.name"
                              :value="option.code"
                            >
                            </el-option>
                          </el-select>
                        </base-input>
                        <!-- <base-input label="Country Code" v-model="business_unit_modal.address_country_code"></base-input> -->
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col md="2">
                        <base-input
                          :label="language_terms['CONTACT_PERSON']"
                          v-model="business_unit_modal.contact_person"
                        ></base-input>
                      </b-col>
                      <b-col md="6">
                        <base-input
                          :label="language_terms['EMAIL']"
                          v-model="business_unit_modal.contact_email"
                        ></base-input>
                      </b-col>
                      <b-col md="2">
                        <base-input
                          :label="language_terms['MOBILE']"
                          v-model="business_unit_modal.contact_mobile"
                        ></base-input>
                      </b-col>
                      <b-col md="3">
                        <base-input
                          :label="language_terms['TELEPHONE']"
                          v-model="business_unit_modal.contact_telephone"
                        ></base-input>
                      </b-col>
                      <b-col md="3">
                        <base-input
                          :label="language_terms['FAX']"
                          v-model="business_unit_modal.contact_fax"
                        ></base-input>
                      </b-col>
                    </b-row>
                  </card>
                </b-col>
              </b-row>
              <template #modal-footer="{ ok, cancel }">
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button variant="primary" @click="createBusinessUnit()">
                  {{language_terms['SAVE']}}
                </b-button>
                <b-button variant="danger" @click="cancelModal()">
                  {{language_terms['CANCEL']}}
                </b-button>
              </template>
            </b-modal>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import priceSetup from '../Components/priceSetup.vue';

import Collapse from "@/components/Collapse/Collapse";
import CollapseItem from "@/components/Collapse/CollapseItem";
import { mapState } from "vuex";
import { Select, Option } from "element-ui";
import bankAccounts from "../Components/bankAccounts.vue";
import Loading from 'vue-loading-overlay';
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import axios from "axios";
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  data() {
    return {
      salechannels:[],
      is_edit:false,
      customerDisabled:true,
      loadCounter:0,
      addUnitModal: false,
      show_unit_tab: false,
      headerBgVariant: "primary",
      headerTextVariant: "light",
      business_unit_modal: {
        name: "",
        country_code: "",
        customer_credit_limit: "",
        customer_credit_term: "",
        address_street: "",
        address_district: "",
        address_city: "",
        address_district: "",
        address_postcode: "",
        address_country_code: "",
        contact_person: "",
        contact_mobile: "",
        contact_telephone: "",
        contact_telephone2: "",
        contact_fax: "",
        contact_fax2: "",
        contact_email: "",
        remarks: "",
      },
      bank_accounts:[],
      customer: {
        contact_categories:[],
        salepersons:[],
        customer_tax_code:'',
        default_debtor_account_code:'',        
        metas:[
          // {
          //   key:"whatsapp",
          //   value:""
          // }
        ],
        customized_price_count:0,
        name: "",
        country_code: "",
        currency_code: "",
        customer_credit_limit: "",
        customer_credit_term: "",
        address_street: "",
        address_district: "",
        address_city: "",
        address_district: "",
        address_postcode: "",
        address_country_code: "",
        contact_person: "",
        contact_mobile: "",
        contact_telephone: "",
        contact_telephone2: "",
        contact_fax: "",
        contact_fax2: "",
        contact_email: "",
        remarks: "",
        bank_accounts:[],
        units: [
          {
            id: "",
            name: "",
            country_code: "",
            currency_code: "",
            customer_credit_limit: "",
            customer_credit_term: "",
            address_street: "",
            address_district: "",
            address_city: "",
            address_district: "",
            address_postcode: "",
            address_country_code: "",
            contact_person: "",
            contact_mobile: "",
            contact_telephone: "",
            contact_telephone2: "",
            contact_fax: "",
            contact_fax2: "",
            contact_email: "",
            remarks: "",
          },
        ],
      },
      options: ["list", "of", "options"],
    };
  },
  components: {
    Loading,
    bankAccounts,
    Collapse,
    CollapseItem,
    [Select.name]: Select,
    [Option.name]: Option,
    priceSetup
  },
  computed: {
    ...mapState({
      salesperson_list:state => state.employees.salesperson_list,
      customer_filter: (state) => state.customers.filter,
      currencies: (state) => state.currencies.currencies,
      taxes: (state) => state.taxes.taxes,
      countries: (state) => state.countries.countries,
      customer_data: (state) => state.customers.data,
      language_terms: (state) => state.languages.language_terms,
      selected_lang: (state) => state.languages.selected_langauge,
      customer_is_created: (state) => state.customers.is_created,
      customer_is_updated: (state) => state.customers.is_updated,
      customer_is_deleted: (state) => state.customers.is_deleted,
      metas_config: (state) => state.customers.metas_config,
      contact_categories: (state) => state.contactCategories.active_list,
      debtor_accounts: (state) => state.customers.debtor_accounts,
    }),
  },
  watch:{
    'customer.bank_accounts':{
        deep: true,
        handler(){
          this.bank_accounts = this.customer.bank_accounts
        }
        
      },
      customer_data:
        {
            deep:true,
            handler(){
                this.customer = this.customer_data
            }
        }
    
  },
  async mounted() 
  {
     this.loadCounter++
      if (this.$route.params.id == "_new") 
      {
        this.setDefaults()
        this.show_unit_tab = false;
        this.customerDisabled = false
        await this.$store.dispatch("customers/fetchMetaConfig", {})
        this.customer.metas = this.metas_config
      } 
      else 
      {
        await this.retrieveCustomer(this.$route.params.id);
        this.bank_accounts = this.customer.bank_accounts
        this.show_unit_tab = true;
        this.customerDisabled = true
      }

      await this.$store.dispatch("customers/fetchDebitorAccounts", {})
      await this.$store.dispatch("countries/fetchAll");
      await this.$store.dispatch("contactCategories/getActiveList", {})
      await this.fetchSaleChannels();
      await this.fetchCurrencies();
      await this.fetchTaxes();
      await this.fetchSalesPersonsForCustomer();

      this.loadCounter--
      console.log(this.debtor_accounts)
  },
  methods: {
    async setDefaults()
    {
      this.customer.customer_tax_code = 'S'
      this.customer.currency_code = 'SGD'
      this.customer.country_code = 'SG'
      this.customer.customer_credit_limit = '0'
      this.customer.customer_credit_term = '0'
      this.default_debtor_account_code = '1513000' 
    },    
    handleCollaspe(index, row)
    {
        if(row.is_collapsed)
        {
           row.is_collapsed = false
        }
        else
        {
          row.is_collapsed = true
        }

        console.log(row)

        this.$set(this.customer.units, index , row) 
    },
    editCustomer()
    {
      this.customerDisabled =false
      this.is_edit= true
    },
    async cancelModal() {
      this.addUnitModal = false;
    },
    async showaddUnitModal() {
      this.addUnitModal = true;
    },
    fetchSalesPersonsForCustomer() {
      this.$store.dispatch("employees/fetchAllSalesPersonForCustomer", {"role_code":"Sales Person"});
    },
    async deleteCustomer()
    {
        let response = await this.$confirm(this.language_terms['ARE_YOU_SURE_DELETE'] + '?', this.language_terms['CONFIRMATION'], {
                  confirmButtonText: this.language_terms['YES'],
                  cancelButtonText: this.language_terms['CANCEL'],
                  type: 'warning'
                }).catch(() => {
              this.$message.info(this.language_terms['ACTION_CANCEL'])
             })
        if (response === 'confirm') 
        {
            this.loadCounter++
            await this.$store.dispatch("customers/delete", this.customer);

            if(this.customer_is_deleted)
            {
                await this.searchCustomer();
                this.$router.push("/sales/customers");
            }
           
            this.loadCounter--
        }
    },
    async deleteUnit(item) 
    {
      if (item.id) 
      {
        let response = await this.$confirm(this.language_terms['ARE_YOU_SURE?'], this.language_terms['CONFIRMATION'], {
                  confirmButtonText: this.language_terms['YES'],
                  cancelButtonText: this.language_terms['CANCEL'],
                  type: 'warning'
                }).catch(() => {
              this.$message.info(this.language_terms['ACTION_CANCEL'])
             })
        if (response === 'confirm') {
             this.loadCounter++
            await this.$store.dispatch("customers/delete", item);
            await this.retrieveCustomer(this.$route.params.id);
            this.customer = this.customer_data;
             this.loadCounter--
        }
      }
    },
    async saveUnit(item) 
    {
      this.loadCounter++
      if (this.customer.id && item.id) 
      {
        item.parent_id = this.customer.id;
        await this.$store.dispatch("customers/update", item);

        if(this.customer_is_updated)
        {
          await this.retrieveCustomer(this.customer.code)
        }
      }
      this.loadCounter--
    },
    async createBusinessUnit() {
      this.loadCounter++
      if (this.customer.id) {
        this.business_unit_modal.parent_id = this.customer.id;
        await this.$store.dispatch(
          "customers/create",
          this.business_unit_modal
        );
        if(this.customer_is_created)
        { 
            await this.retrieveCustomer(this.$route.params.id);
            this.customer = this.customer_data;

            this.business_unit_modal = {
                  name: "",
                  country_code: "",
                  customer_credit_limit: "",
                  customer_credit_term: "",
                  address_street: "",
                  address_district: "",
                  address_city: "",
                  address_district: "",
                  address_postcode: "",
                  address_country_code: "",
                  contact_person: "",
                  contact_mobile: "",
                  contact_telephone: "",
                  contact_telephone2: "",
                  contact_fax: "",
                  contact_fax2: "",
                  contact_email: "",
                  remarks: ""
            }

            this.addUnitModal = false;

        }

        this.loadCounter--
      }
    },
    async retrieveCustomer(code) {
      this.loadCounter++
      await this.$store.dispatch("customers/fetch", {
        code: code,
      });

      this.customer = this.customer_data;
      this.loadCounter--
    },
    addDepartment() {
      this.loadCounter++
      this.customer.units.push({
        id: "",
        name: "",
        country_code: "",
        currency_code: "",
        customer_credit_limit: "",
        customer_credit_term: "",
        address_street: "",
        address_district: "",
        address_city: "",
        address_district: "",
        address_postcode: "",
        address_country_code: "",
        contact_person: "",
        contact_mobile: "",
        contact_telephone: "",
        contact_telephone2: "",
        contact_fax: "",
        contact_fax2: "",
        contact_email: "",
        remarks: "",
      });
      this.loadCounter--
    },
    fetchSaleChannels() {
      let payload = {};
      axios.post(apiRoutes["SALE_CHANNEL_QUICK_SEARCH"], payload, authHeader()).then((response) => {
        if (response.data.code == 1) 
        {
          this.salechannels = response.data.data
        } 
        else 
        {
          this.salechannels = []
        }
      })
      .catch((error) => 
      {
        if (error.response) 
        {
          Vue.notify({group: "notify",type: "error",text: error.response, max: 5,duration: 5000,speed: 300,});
        } 
      });

    },
    fetchCurrencies() {
      this.loadCounter++
      this.$store.dispatch("currencies/fetchAll", {});
      this.loadCounter--
    },
    fetchTaxes() {
      this.loadCounter++
      this.$store.dispatch("taxes/fetchAll", { type: "Sales" });
      this.loadCounter--
    },
    async searchCustomer()
    {
        this.loadCounter++
        let filter = {keyword:"",active_only:"1"}
        if(this.customer_filter)
        {
            filter = this.customer_filter
        }
        await this.$store.dispatch('customers/quickSearch', filter)

        this.loadCounter--
    },
    async saveCustomer() {
      this.loadCounter++
      if (this.$route.params.id == "_new") 
      {
        await this.$store.dispatch("customers/create", this.customer);

        if(this.customer_is_created)
        {
          // refresh the store
          await this.searchCustomer();
          this.$router.push("/sales/customers");
        }
      } 
      else 
      {
        await this.$store.dispatch("customers/update", this.customer);
        if(this.customer_is_updated)
        {
            await this.searchCustomer();
            this.$router.push("/sales/customers");
        }
      }
      this.loadCounter--
    },
    cancelCustomer() {
      if(this.$route.params.id == '_new')
          this.$router.push("/sales/customers")
      else
          location.reload();
    },
  },
};
</script>
